import Icon from '../components/Icon.vue'

Icon.register({"history":{"width":512,"height":512,"paths":[{"d":"M504 255.5C504.3 392.2 392.8 503.9 256.2 504 197.2 504 143 483.5 100.4 449.1 89.3 440.1 88.5 423.5 98.5 413.5L109.8 402.2C118.4 393.6 132.1 392.7 141.7 400.2 173.1 425.1 212.8 440 256 440 357.7 440 440 357.7 440 256 440 154.3 357.7 72 256 72 207.2 72 162.9 91 129.9 121.9L180.7 172.7C190.8 182.8 183.6 200 169.4 200H24C15.2 200 8 192.8 8 184V38.6C8 24.4 25.2 17.2 35.3 27.3L84.7 76.7C129.2 34.1 189.6 8 256 8 392.8 8 503.7 118.8 504 255.5zM323.1 334.3L332.9 321.7C341 311.2 339.2 296.1 328.7 288L288 256.3V152C288 138.7 277.3 128 264 128H248C234.7 128 224 138.7 224 152V287.7L289.4 338.5C299.9 346.7 314.9 344.8 323.1 334.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/history.js
// module id = Os+9
// module chunks = 0